__turbopack_context__.v({
  "settingsBackButton": "NkQ-ca_settingsBackButton",
});
